import React from "react";

import { ViaIcon } from "@/shared/components/ViaIcon";
import type { InterfaceDef } from "@/shared/types";

/* The same theme-aware channel glyph used in chats, on a sunk tile. */
export function InterfaceIcon({ meta, size = 36, iconSize = 18, rounded = 10 }: {
  meta: InterfaceDef;
  size?: number;
  iconSize?: number;
  rounded?: number;
}) {
  return (
    <div
      className="shrink-0 bg-[var(--surface-2)] flex items-center justify-center"
      style={{ width: size, height: size, borderRadius: rounded }}
    >
      <ViaIcon type={meta.type} size={iconSize} decorative />
    </div>
  );
}
